import React from 'react';
import {
  Button,
  Stack,
  UnorderedList,
} from '@chakra-ui/react';
import {Control, UseFormRegister} from 'react-hook-form/dist/types/form';
import {RegisterOptions} from 'react-hook-form/dist/types/validator';
import {FieldPath, useFieldArray} from 'react-hook-form';
import {DndProvider} from 'react-dnd';
import {HTML5Backend} from 'react-dnd-html5-backend';
import ListItem from './Item';
import {AddIcon} from '@chakra-ui/icons';
import {IOppskriftFields} from 'types';

type IProps = {
  currentApproch?: string[];
  register: UseFormRegister<IOppskriftFields>;
  options?: RegisterOptions<IOppskriftFields, FieldPath<IOppskriftFields>>
  control: Control<IOppskriftFields, object>
  onBlur?: () => void;
};

const Approch: React.FC<IProps> = ({
  currentApproch,
  register,
  options,
  control,
  onBlur,
}) => {
  const {fields, append, remove, swap} = useFieldArray({
    control,
    name: 'approch',
  });

  React.useEffect(() => {
    // @ts-ignore
    if (fields.map((field) => field.value) != currentApproch && currentApproch) {
      currentApproch?.forEach((step) => {
        append({value: step});
      });
    }
  },
  [currentApproch]);

  return (
    <UnorderedList m="0" listStyleType="none">
      <Stack gap='4'>
        <DndProvider backend={HTML5Backend}>
          {fields.map((field, i) => {
            const id = 'approch.' + (i) + '.value';
            // @ts-ignore
            return (<ListItem key={field.id} name={id} register={register} options={options} field={field}
              placeholder={'Skriv steget her'}
              label='Steg '
              type="steg"
              remove={remove}
              i={i}
              swap={swap}
              onBlur={onBlur}
            />);
          })}
        </DndProvider>
        <Button colorScheme="blue" rightIcon={<AddIcon boxSize={3} />}
          onClick={() => {
            append({value: ''});
          }}>Legg til steg</Button>
      </Stack>
    </UnorderedList>
  );
};

export default Approch;
